import { render } from "./Constitucion-App.vue?vue&type=template&id=7b456f3a&scoped=true"
import script from "./Constitucion-App.vue?vue&type=script&lang=js"
export * from "./Constitucion-App.vue?vue&type=script&lang=js"

import "./Constitucion-App.vue?vue&type=style&index=0&id=7b456f3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b456f3a"]])

export default __exports__